// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 10%27><path d=%27M1 5L4 8L9 2%27 stroke=%27black%27 stroke-width=%271.7%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 10%27><path d=%27M1 5L4 8L9 2%27 stroke=%27black%27 stroke-width=%271.6%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Filters — the filter UX: a compact dropdown (FilterDropdown) and the
   single "Filtros" button + panel + applied chips (FilterButton / FilterChips).
   Imported by both FilterDropdown and Filters. */

/* dropdown shell */
.fdrop {
  position: relative;
}
.fdrop__scrim {
  position: fixed;
  inset: 0;
  z-index: 40;
}
.fbtn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 11px;
  border: 1px solid var(--border);
  background: var(--surface);
  border-radius: var(--radius-1);
  font-family: var(--sans);
  font-size: var(--fs-ui);
  color: var(--text);
  cursor: pointer;
  white-space: nowrap;
  transition: border-color var(--dur-1) var(--ease);
}
.fbtn:hover {
  border-color: var(--text-muted);
}
.fbtn--on {
  border-color: var(--accent);
}
.fbtn__k {
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.fbtn--on .fbtn__k {
  color: var(--accent-deep);
}
.fbtn__v {
  color: var(--text);
}
.fbtn svg {
  color: var(--text-muted);
  flex: none;
}

/* per-filter multi-select menu (FilterDropdown) */
.fmenu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 50;
  min-width: 230px;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  padding: 5px;
}
.fmenu__item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  background: transparent;
  border: 0;
  font-family: var(--sans);
  font-size: var(--fs-ui);
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: var(--radius-1);
  text-align: left;
}
.fmenu__item:hover {
  background: var(--bg-alt);
  color: var(--text);
}
.fmenu__box {
  width: 15px;
  height: 15px;
  border: 1px solid var(--text-muted);
  border-radius: 2px;
  flex: none;
  display: grid;
  place-items: center;
}
.fmenu__item.is-on {
  color: var(--text);
}
.fmenu__item.is-on .fmenu__box {
  background: var(--accent);
  border-color: var(--accent);
}
.fmenu__item.is-on .fmenu__box::after {
  content: '';
  width: 9px;
  height: 9px;
  /* Mask painted with --accent-ink, so the check reads on the dark accents. */
  background: var(--accent-ink);
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    center/contain no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    center/contain no-repeat;
}
.fmenu__lbl {
  flex: 1;
}
.fmenu__n {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}
.fmenu__item.is-on .fmenu__n {
  color: var(--accent-deep);
}

/* single "Filtros" button + count badge */
.fbtn--filters {
  gap: 7px;
}
.fbtn--filters svg {
  color: var(--text-muted);
}
.fbtn--filters.fbtn--on svg:first-child {
  color: var(--accent-deep);
}
.fbtn__badge {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  font-weight: 600;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  display: inline-grid;
  place-items: center;
  background: var(--accent);
  color: var(--accent-ink);
  border-radius: 999px;
  font-variant-numeric: tabular-nums;
}

/* the grouped filter panel */
.fpanel {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 50;
  width: 280px;
  max-height: 420px;
  overflow-y: auto;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  animation: reveal var(--dur-2) var(--ease) both;
}
.fpanel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 10px;
  border-bottom: 1px solid var(--border-soft);
  position: sticky;
  top: 0;
  background: var(--surface);
}
.fpanel__title {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.fpanel__clear {
  background: transparent;
  border: 0;
  padding: 0;
  font-family: var(--sans);
  font-size: var(--fs-meta);
  color: var(--accent-deep);
  cursor: pointer;
}
.fpanel__clear:hover {
  text-decoration: underline;
}
.fpanel__body {
  padding: 6px;
}
.fgroup {
  padding: 8px 6px;
}
.fgroup + .fgroup {
  border-top: 1px solid var(--border-soft);
}
.fgroup__label {
  display: flex;
  align-items: center;
  gap: 7px;
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted);
  padding: 0 8px 6px;
}
.fgroup__n {
  font-size: var(--fs-pico);
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  display: inline-grid;
  place-items: center;
  background: var(--accent);
  color: var(--accent-ink);
  border-radius: 999px;
}
.fgroup__opts {
  display: flex;
  flex-direction: column;
}
/* Footnote under the Columnas list — names the always-on columns. */
.fgroup__note {
  padding: 8px 8px 2px;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
.fopt {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 8px;
  background: transparent;
  border: 0;
  font-family: var(--sans);
  font-size: var(--fs-ui);
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: var(--radius-1);
  text-align: left;
}
.fopt:hover {
  background: var(--bg-alt);
  color: var(--text);
}
.fopt__box {
  width: 15px;
  height: 15px;
  border: 1px solid var(--text-muted);
  border-radius: 2px;
  flex: none;
  display: grid;
  place-items: center;
}
.fopt.is-on {
  color: var(--text);
}
.fopt.is-on .fopt__box {
  background: var(--accent);
  border-color: var(--accent);
}
.fopt.is-on .fopt__box::after {
  content: '';
  width: 9px;
  height: 9px;
  /* Mask painted with --accent-ink, so the check reads on the dark accents. */
  background: var(--accent-ink);
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    center/contain no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    center/contain no-repeat;
}
.fopt__lbl {
  flex: 1;
}
.fopt__n {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}
.fopt.is-on .fopt__n {
  color: var(--accent-deep);
}

/* applied-filter chips */
.fchips {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  margin-top: 14px;
}
.fchip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 28px;
  padding: 0 8px 0 10px;
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: var(--radius-1);
  font-family: var(--sans);
  font-size: var(--fs-2xs);
  color: var(--text);
  cursor: pointer;
}
.fchip:hover {
  border-color: var(--text-muted);
}
.fchip__g {
  font-family: var(--mono);
  font-size: var(--fs-pico);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.fchip__v {
  color: var(--text);
}
.fchip svg {
  color: var(--text-muted);
  flex: none;
}
.fchip:hover svg {
  color: var(--text);
}
.fchip--clear {
  padding: 0 10px;
  color: var(--text-muted);
  background: transparent;
  border-style: dashed;
}
.fchip--clear:hover {
  color: var(--text);
}
`, "",{"version":3,"sources":["webpack://./src/ui/Filters/Filters.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,mBAAmB;AACnB;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;EAC1B,8BAA8B;EAC9B,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iDAAiD;AACnD;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,4EAA4E;EAC5E,6BAA6B;EAC7B;4BAC0B;EAC1B;4BAC0B;AAC5B;AACA;EACE,OAAO;AACT;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,QAAQ;AACV;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,yBAAyB;EACzB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,2CAA2C;EAC3C,gBAAgB;EAChB,MAAM;EACN,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA,oEAAoE;AACpE;EACE,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,4EAA4E;EAC5E,6BAA6B;EAC7B;4BAC0B;EAC1B;4BAC0B;AAC5B;AACA;EACE,OAAO;AACT;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB","sourcesContent":["/* Filters — the filter UX: a compact dropdown (FilterDropdown) and the\n   single \"Filtros\" button + panel + applied chips (FilterButton / FilterChips).\n   Imported by both FilterDropdown and Filters. */\n\n/* dropdown shell */\n.fdrop {\n  position: relative;\n}\n.fdrop__scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 40;\n}\n.fbtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 34px;\n  padding: 0 11px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  border-radius: var(--radius-1);\n  font-family: var(--sans);\n  font-size: var(--fs-ui);\n  color: var(--text);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color var(--dur-1) var(--ease);\n}\n.fbtn:hover {\n  border-color: var(--text-muted);\n}\n.fbtn--on {\n  border-color: var(--accent);\n}\n.fbtn__k {\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.fbtn--on .fbtn__k {\n  color: var(--accent-deep);\n}\n.fbtn__v {\n  color: var(--text);\n}\n.fbtn svg {\n  color: var(--text-muted);\n  flex: none;\n}\n\n/* per-filter multi-select menu (FilterDropdown) */\n.fmenu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 50;\n  min-width: 230px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow);\n  padding: 5px;\n}\n.fmenu__item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px 10px;\n  background: transparent;\n  border: 0;\n  font-family: var(--sans);\n  font-size: var(--fs-ui);\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: var(--radius-1);\n  text-align: left;\n}\n.fmenu__item:hover {\n  background: var(--bg-alt);\n  color: var(--text);\n}\n.fmenu__box {\n  width: 15px;\n  height: 15px;\n  border: 1px solid var(--text-muted);\n  border-radius: 2px;\n  flex: none;\n  display: grid;\n  place-items: center;\n}\n.fmenu__item.is-on {\n  color: var(--text);\n}\n.fmenu__item.is-on .fmenu__box {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n.fmenu__item.is-on .fmenu__box::after {\n  content: '';\n  width: 9px;\n  height: 9px;\n  /* Mask painted with --accent-ink, so the check reads on the dark accents. */\n  background: var(--accent-ink);\n  -webkit-mask: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10'><path d='M1 5L4 8L9 2' stroke='black' stroke-width='1.7' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")\n    center/contain no-repeat;\n  mask: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10'><path d='M1 5L4 8L9 2' stroke='black' stroke-width='1.7' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")\n    center/contain no-repeat;\n}\n.fmenu__lbl {\n  flex: 1;\n}\n.fmenu__n {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n.fmenu__item.is-on .fmenu__n {\n  color: var(--accent-deep);\n}\n\n/* single \"Filtros\" button + count badge */\n.fbtn--filters {\n  gap: 7px;\n}\n.fbtn--filters svg {\n  color: var(--text-muted);\n}\n.fbtn--filters.fbtn--on svg:first-child {\n  color: var(--accent-deep);\n}\n.fbtn__badge {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  font-weight: 600;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  display: inline-grid;\n  place-items: center;\n  background: var(--accent);\n  color: var(--accent-ink);\n  border-radius: 999px;\n  font-variant-numeric: tabular-nums;\n}\n\n/* the grouped filter panel */\n.fpanel {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 50;\n  width: 280px;\n  max-height: 420px;\n  overflow-y: auto;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow);\n  animation: reveal var(--dur-2) var(--ease) both;\n}\n.fpanel__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px 10px;\n  border-bottom: 1px solid var(--border-soft);\n  position: sticky;\n  top: 0;\n  background: var(--surface);\n}\n.fpanel__title {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.fpanel__clear {\n  background: transparent;\n  border: 0;\n  padding: 0;\n  font-family: var(--sans);\n  font-size: var(--fs-meta);\n  color: var(--accent-deep);\n  cursor: pointer;\n}\n.fpanel__clear:hover {\n  text-decoration: underline;\n}\n.fpanel__body {\n  padding: 6px;\n}\n.fgroup {\n  padding: 8px 6px;\n}\n.fgroup + .fgroup {\n  border-top: 1px solid var(--border-soft);\n}\n.fgroup__label {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  padding: 0 8px 6px;\n}\n.fgroup__n {\n  font-size: var(--fs-pico);\n  min-width: 14px;\n  height: 14px;\n  padding: 0 3px;\n  display: inline-grid;\n  place-items: center;\n  background: var(--accent);\n  color: var(--accent-ink);\n  border-radius: 999px;\n}\n.fgroup__opts {\n  display: flex;\n  flex-direction: column;\n}\n/* Footnote under the Columnas list — names the always-on columns. */\n.fgroup__note {\n  padding: 8px 8px 2px;\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n}\n.fopt {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 7px 8px;\n  background: transparent;\n  border: 0;\n  font-family: var(--sans);\n  font-size: var(--fs-ui);\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: var(--radius-1);\n  text-align: left;\n}\n.fopt:hover {\n  background: var(--bg-alt);\n  color: var(--text);\n}\n.fopt__box {\n  width: 15px;\n  height: 15px;\n  border: 1px solid var(--text-muted);\n  border-radius: 2px;\n  flex: none;\n  display: grid;\n  place-items: center;\n}\n.fopt.is-on {\n  color: var(--text);\n}\n.fopt.is-on .fopt__box {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n.fopt.is-on .fopt__box::after {\n  content: '';\n  width: 9px;\n  height: 9px;\n  /* Mask painted with --accent-ink, so the check reads on the dark accents. */\n  background: var(--accent-ink);\n  -webkit-mask: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10'><path d='M1 5L4 8L9 2' stroke='black' stroke-width='1.6' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")\n    center/contain no-repeat;\n  mask: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10'><path d='M1 5L4 8L9 2' stroke='black' stroke-width='1.6' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")\n    center/contain no-repeat;\n}\n.fopt__lbl {\n  flex: 1;\n}\n.fopt__n {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n.fopt.is-on .fopt__n {\n  color: var(--accent-deep);\n}\n\n/* applied-filter chips */\n.fchips {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n  margin-top: 14px;\n}\n.fchip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 28px;\n  padding: 0 8px 0 10px;\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1);\n  font-family: var(--sans);\n  font-size: var(--fs-2xs);\n  color: var(--text);\n  cursor: pointer;\n}\n.fchip:hover {\n  border-color: var(--text-muted);\n}\n.fchip__g {\n  font-family: var(--mono);\n  font-size: var(--fs-pico);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.fchip__v {\n  color: var(--text);\n}\n.fchip svg {\n  color: var(--text-muted);\n  flex: none;\n}\n.fchip:hover svg {\n  color: var(--text);\n}\n.fchip--clear {\n  padding: 0 10px;\n  color: var(--text-muted);\n  background: transparent;\n  border-style: dashed;\n}\n.fchip--clear:hover {\n  color: var(--text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
